/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75.5 128C46.505 128 23 104.495 23 75.5S46.505 23 75.5 23 128 46.505 128 75.5 104.495 128 75.5 128zm11.989-41c-.086 3.796-5.64 6.86-12.492 6.86-6.848 0-12.408-3.064-12.489-6.86-9.601.888-17.292.163-18.508 16h62c-1.219-15.837-8.91-15.112-18.511-16zM75 89c9.39 0 17-14.293 17-23.793C92 55.702 84.39 48 75 48c-9.388 0-17 7.705-17 17.207C58 74.71 65.612 89 75 89z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
